// @flow

import type { Node } from 'react';
import React, { createContext, useContext } from 'react';

import type { StaticLabelsProviderProps } from './types';

const StaticLabelsContext = createContext(null);

export const useStaticLabelsContext = () => useContext(StaticLabelsContext);

export const StaticLabelsProvider = ({ children, labels }: StaticLabelsProviderProps): Node => (
  <StaticLabelsContext.Provider value={labels}>{children}</StaticLabelsContext.Provider>
);
